let agencias = [
    {
        id: 4434,
        name: 'Nova Santa Rita',
    },
]

export {agencias}